import React, { PropsWithChildren } from 'react';

import { ApiClientManager } from '@api/consumerloans-public-api';
import { TestComponent } from '@components';
import { render } from '@testing-library/react';

interface TestHelperHookTestInput<THookFnOutput, THookForDoingChangesOutput> {
	hookFn: () => THookFnOutput;
	// hookForDoingChanges?: (() => THookForDoingChangesOutput) => void;
}

interface TestHelperServiceHookTestInput<T> {
	hookFn: () => T;
	apiMethodName: string;
	successResponse?: any;
}

export class TestHelper {
	static hookTest = <THookFnOutput,>(input: TestHelperHookTestInput<THookFnOutput, any>): THookFnOutput => {
		const { hookFn } = input;
		const returnVal = {};
		const execVal = {};

		const ExecuteHookForDoingChanges: React.FC<PropsWithChildren> = ({ children }) => {
			// Object.assign(execVal, hookForDoingChanges?.hookFn());
			return <>{children}</>;
		};

		const ExecuteHookForDoingChange2: React.FC<PropsWithChildren> = ({ children }) => {
			// hookForDoingChanges?.execFn?.(execVal as any);
			return <>{children}</>;
		};

		const ExecuteHookForGetReturn: React.FC<PropsWithChildren> = ({ children }) => {
			Object.assign(returnVal, hookFn());
			return <>{children}</>;
		};

		render(
			<TestComponent>
				<ExecuteHookForDoingChanges>
					<ExecuteHookForDoingChange2>
						<ExecuteHookForGetReturn />
					</ExecuteHookForDoingChange2>
				</ExecuteHookForDoingChanges>
			</TestComponent>
		);

		return returnVal as any;
	};

	static serviceHookTest = async <T,>(input: TestHelperServiceHookTestInput<T>): Promise<T> => {
		const { hookFn, apiMethodName, successResponse } = input;
		const returnVal: any = {};

		const TestComp: React.FC = () => {
			Object.assign(returnVal, hookFn());
			return null;
		};

		render(
			<TestComponent>
				<TestComp />
			</TestComponent>
		);

		(ApiClientManager.call as any)[apiMethodName] = () => Promise.resolve(successResponse);

		return returnVal.fetch();
	};
}
